export default {
    topics: [
        {
            title: ' FTP ',
            href: 'm-FTP-FTP.html',
            attributes: { 'data-id': 'm-FTP-FTP' },
            menu: { hasChildren: false },
            tocID: 'm-FTP-FTP-d66e5329',
            topics: [],
        },
        {
            title: ' dispose ',
            href: 'm-FTP-dispose.html',
            attributes: { 'data-id': 'm-FTP-dispose' },
            menu: { hasChildren: false },
            tocID: 'm-FTP-dispose-d66e5337',
            topics: [],
        },
        {
            title: ' download ',
            href: 'm-FTP-download.html',
            attributes: { 'data-id': 'm-FTP-download' },
            menu: { hasChildren: false },
            tocID: 'm-FTP-download-d66e5345',
            topics: [],
        },
        {
            title: ' list ',
            href: 'm-FTP-list.html',
            attributes: { 'data-id': 'm-FTP-list' },
            menu: { hasChildren: false },
            tocID: 'm-FTP-list-d66e5353',
            topics: [],
        },
        {
            title: ' setFile ',
            href: 'm-FTP-setFile.html',
            attributes: { 'data-id': 'm-FTP-setFile' },
            menu: { hasChildren: false },
            tocID: 'm-FTP-setFile-d66e5361',
            topics: [],
        },
        {
            title: ' upload ',
            href: 'm-FTP-upload.html',
            attributes: { 'data-id': 'm-FTP-upload' },
            menu: { hasChildren: false },
            tocID: 'm-FTP-upload-d66e5369',
            topics: [],
        },
    ],
};

